import { z } from "zod";


// ContratoServicoSchema

const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalDecimal = z.coerce.number().nullable().optional();
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);

export const ContratoServicoSchema = z.object({
  IdContratoServico: z.number().int().default(0),
  IdContrato: optionalNumber,
  IdProdutoServico: optionalNumber,
  Detalhamento: optionalString,
  Quantidade: optionalDecimal,
  ValorUnitario: optionalDecimal,
  ValorTotal: optionalDecimal,
});

// ContratoServicoForm
export type ContratoServicoForm = z.infer<typeof ContratoServicoSchema>;